/* Goodest Boy buy box: dog count, per-dog name + size, plan, live prices, first-box card, sticky bar,
   add to cart (one line per dog, name + plan as properties), then waitlist dialog or cart/checkout. */
(function () {
  var root = document.querySelector("[data-gb-cfg]");
  if (!root) return;
  var cfg = JSON.parse(root.textContent), T = cfg.t, wrap = root.closest(".gb");
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var SUB = cfg.sub, B = cfg.bands.length ? cfg.bands : [{ label: "", bottle: 1, dose: "", mg: "" }];
  var db = Math.min(Math.max(cfg.defaultBand, 0), B.length - 1);
  var st = { n: 1, band: [db, db, db], name: cfg.names.slice(), sub: true };
  function sizeOf(i) { return B[st.band[i]].bottle; }
  function sp(w) { return w ? " " + String(w).trim() : ""; }
  function money(n) { return "$" + (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0); }
  function fill(s, o) { return String(s || "").replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  // gallery
  var main = $(".gb-main img", wrap), tagt = $("[data-gb-tagtxt]", wrap);
  $$("[data-gb-thumbs] button", wrap).forEach(function (b) {
    b.addEventListener("click", function () {
      if (main) { main.removeAttribute("srcset"); main.removeAttribute("sizes"); main.src = b.getAttribute("data-gb-full"); }
      if (tagt) tagt.hidden = !b.hasAttribute("data-gb-tagged");
      $$("[data-gb-thumbs] button", wrap).forEach(function (x) { x.setAttribute("aria-pressed", x === b); });
    });
  });
  var subOn = !!$('.gb-opt[data-gb-p="1"]', wrap); // false when the page hides the subscribe option
  var cnt = $("[data-gb-cnt]", wrap), dogs = $("[data-gb-dogs]", wrap), cta = $("[data-gb-cta]", wrap), under = $("[data-gb-under]", wrap);
  [1, 2, 3].forEach(function (k) {
    var b = document.createElement("button"); b.type = "button";
    b.innerHTML = k + " " + (k === 1 ? T.dog : T.dogs) + "<small>" + (!subOn ? (T.from ? T.from + " " : "") + money(Math.min.apply(null, [0, 1, 2].map(onceOf))) + (k === 1 ? "" : sp(T.each)) : k === 1 ? money(SUB[1]) : money(SUB[k] / k) + sp(T.each)) + "</small>";
    b.addEventListener("click", function () { st.n = k; render(true); }); cnt.appendChild(b);
  });
  $$(".gb-opt", wrap).forEach(function (o) { o.addEventListener("click", function () { st.sub = o.getAttribute("data-gb-p") === "1"; render(false); }); });
  if (!$('.gb-opt[data-gb-p="0"]', wrap)) st.sub = true;
  if (!$('.gb-opt[data-gb-p="1"]', wrap)) st.sub = false;
  function onceOf(z) { return cfg.vp && cfg.vp[z] != null ? cfg.vp[z] / 100 : (z === 2 ? cfg.onceGrand : cfg.once); }
  function wasOf(z) { var c = cfg.vc && cfg.vc[z]; return c ? c / 100 : 0; }
  function totals() { var g = 0, once = 0, was = 0; for (var i = 0; i < st.n; i++) { var z = sizeOf(i); if (z === 2) g++; once += onceOf(z); was += wasOf(z) || onceOf(z); } return { sub: SUB[st.n] + cfg.grandUp * g, once: once, was: was > once ? was : 0 }; }
  function names() { return st.name.slice(0, st.n).map(function (s) { return (s || "").trim(); }); }
  function who() {
    var ns = names().filter(Boolean);
    if (st.n === 1) return (ns[0] ? ns[0] + "'s" : T.her) + " drops";
    if (st.n === 2 && ns.length === 2) return ns[0] + " + " + ns[1] + "'s drops";
    return fill(T.all, { n: st.n });
  }
  function render(rebuild) {
    var t = totals();
    Array.prototype.forEach.call(cnt.children, function (b, i) { b.setAttribute("aria-pressed", i + 1 === st.n); });
    if (rebuild) {
      dogs.innerHTML = "";
      for (var i = 0; i < st.n; i++) (function (i) {
        var d = document.createElement("div"); d.className = "gb-dog";
        var ph = fill(T.namePh, { n: i + 1 });
        d.innerHTML = '<label class="gb-nmf"><input aria-label="' + esc(ph) + '" maxlength="12" placeholder="' + esc(ph) + '" value="' + esc(st.name[i] || "") + '" autocomplete="off"><span>' + esc(T.badge) + '</span></label><div class="gb-sz"></div><p class="gb-supply"></p>';
        var sz = d.querySelector(".gb-sz");
        B.forEach(function (bd, j) { var b = document.createElement("button"); b.type = "button"; b.innerHTML = esc(bd.label) + "<small>" + esc(cfg.sizes[bd.bottle] + " · " + bd.dose) + "</small>"; b.addEventListener("click", function () { st.band[i] = j; render(false); }); sz.appendChild(b); });
        d.querySelector("input").addEventListener("input", function (e) { st.name[i] = e.target.value; render(false); });
        dogs.appendChild(d);
      })(i);
    }
    $$(".gb-dog", dogs).forEach(function (d, i) { $$(".gb-sz button", d).forEach(function (b, j) { b.setAttribute("aria-pressed", st.band[i] === j); }); });
    $$(".gb-dog", dogs).forEach(function (d, i) {
      var p = d.querySelector(".gb-supply"); if (!p) return;
      var bd = B[st.band[i]], nm = names()[i] || (st.n > 1 ? "Dog " + (i + 1) : T.her.charAt(0).toUpperCase() + T.her.slice(1));
      p.textContent = T.supply ? fill(T.supply, { name: nm, dose: bd.dose, size: cfg.sizes[bd.bottle], days: bd.days || 30 }) + (T.sqDef && i === 0 ? " " + T.sqDef : "") : "";
      p.hidden = !T.supply;
    });
    $$(".gb-opt", wrap).forEach(function (o) { o.setAttribute("aria-pressed", (o.getAttribute("data-gb-p") === "1") === st.sub); });
    var per = st.n > 1 ? sp(T.perDog) : "";
    var subP = $("[data-gb-sp]", wrap), sd = $("[data-gb-sd]", wrap), op = $("[data-gb-op]", wrap), od = $("[data-gb-od]", wrap);
    if (subP) subP.textContent = money(t.sub);
    if (sd) sd.textContent = money(t.sub / 30 / st.n) + sp(T.aDay) + per;
    if (op) op.innerHTML = (t.was ? '<s style="opacity:.5;font-weight:600;margin-right:6px">' + money(t.was) + "</s>" : "") + money(t.once);
    if (od) od.textContent = money(t.once / 30 / st.n) + sp(T.aDay) + per + (t.was ? " · " + fill(T.save || "You save {save}", { save: money(t.was - t.once) }) : "") + (T.onceNote ? " · " + T.onceNote : "");
    cta.textContent = fill(T.cta, { who: who(), price: money(st.sub ? t.sub : t.once) });
    under.textContent = (st.sub ? fill(T.underSub, { price: money(t.sub) }) : fill(T.underOnce, { save: money(t.once - t.sub) })) + (T.guar ? " " + T.guar : "");
    var nm = names()[0] || T.her.charAt(0).toUpperCase() + T.her.slice(1);
    $$("[data-gb-nm]").forEach(function (e) { e.textContent = nm; });
    if (tagt) tagt.style.fontSize = Math.min(18, 104 / (nm.length * 0.8)) + "px";
    var sb = $("[data-gb-stickybtn]"); if (sb) sb.textContent = fill(T.sticky, { who: who() });
    var list = $("[data-gb-boxlist]");
    if (list) {
      var items = [];
      for (var i = 0; i < st.n; i++) { var bd = B[st.band[i]]; items.push("<li>" + esc(fill(T.boxLine, { name: names()[i] || ("Dog " + (i + 1)), size: cfg.sizes[bd.bottle], dose: bd.dose, mg: bd.mg })) + "</li>"); }
      if (st.sub) String(T.boxPerks || "").split(",").forEach(function (p) { if (p.trim()) items.push("<li>" + esc(p.trim()) + "</li>"); });
      else if (T.boxOnce) items.push("<li>" + esc(T.boxOnce) + "</li>");
      list.innerHTML = items.join("");
      var bt = $("[data-gb-boxtitle]"); if (bt) bt.textContent = st.n === 1 ? fill(T.boxOne, { name: nm }) : fill(T.boxMany, { n: st.n });
      var bn = $("[data-gb-boxnext]"); if (bn) bn.textContent = st.sub ? fill(T.nextSub, { price: money(t.sub) }) : T.nextOnce;
    }
  }
  render(true);
  // add to cart -> waitlist dialog, cart or checkout
  var dlg = $("[data-gb-dialog]", wrap);
  function openDialog() {
    if (!dlg) return;
    var h = $("[data-gb-wl-h]", dlg); if (h) h.textContent = fill(h.getAttribute("data-tpl") || (h.setAttribute("data-tpl", h.textContent), h.textContent), { name: names()[0] || "Your dog" });
    var tg = $("[data-gb-wl-tags]", dlg);
    if (tg) {
      var base = tg.getAttribute("data-base") || (tg.setAttribute("data-base", tg.value), tg.value);
      var tags = [base, st.sub ? "plan-subscribe" : "plan-once", "dogs-" + st.n];
      for (var i = 0; i < st.n; i++) tags.push("size-" + String(cfg.sizes[sizeOf(i)]).toLowerCase());
      tg.value = tags.join(", ");
    }
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", "");
  }
  if (dlg) {
    $$("[data-gb-close]", dlg).forEach(function (b) { b.addEventListener("click", function () { dlg.close(); }); });
    if ($("[data-gb-wl-done]", dlg) || $("[data-gb-wl-err]", dlg)) openDialog();
  }
  cta.addEventListener("click", function () {
    var items = [];
    for (var i = 0; i < st.n; i++) {
      var props = { "Plan": st.sub ? "Subscribe" : "One-time" }; var n = names()[i]; if (n) props["Dog name"] = n;
      props["Daily dose"] = B[st.band[i]].dose + " (" + B[st.band[i]].label + ")";
      items.push({ id: cfg.variants[sizeOf(i)], quantity: 1, properties: props });
    }
    cta.disabled = true;
    var direct = !cfg.waitlist && cfg.after === "checkout", J = { "Content-Type": "application/json", "Accept": "application/json" };
    if (direct) { cta.classList.add("gb-busy"); cta.innerHTML = '<span class="gb-spin"></span>' + esc(T.adding || ""); }
    // straight to checkout: start from an empty cart so a second click (or Back, then buy again) never doubles the order
    (direct && (cfg.cartCount > 0 || st.added) ? fetch("/cart/clear.js", { method: "POST", headers: J }) : Promise.resolve())
      .then(function () { return fetch("/cart/add.js", { method: "POST", headers: J, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        if (cfg.waitlist) { cta.disabled = false; fetch("/cart/clear.js", { method: "POST", headers: J }); openDialog(); }
        else if (direct) { st.added = true; cta.innerHTML = '<span class="gb-spin"></span>' + esc(T.going || ""); location.href = "/checkout"; }
        else location.href = "/cart";
      })
      .catch(function (e) {
        cta.disabled = false; cta.classList.remove("gb-busy"); render(false);
        if (cfg.waitlist) openDialog();
        else if (e && (e.description || e.message)) under.textContent = e.description || e.message;
      });
  });
  window.addEventListener("pageshow", function (e) { if (e.persisted) { cta.disabled = false; cta.classList.remove("gb-busy"); render(false); } });
  var sticky = $("[data-gb-sticky]", wrap);
  if (sticky && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) {
      var past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      sticky.classList.toggle("gb-on", past); sticky.setAttribute("aria-hidden", !past);
      sticky.querySelector("a").tabIndex = past ? 0 : -1;
    }).observe(cta);
  }
})();
